export const ORDER_TAX_RATE = 0.04;

export function calculateOrderTotalWithTax(subtotal) {
  const normalizedSubtotal = Number(Number(subtotal).toFixed(2));
  const tax = Number((normalizedSubtotal * ORDER_TAX_RATE).toFixed(2));
  const total = Number((normalizedSubtotal + tax).toFixed(2));
  return { subtotal: normalizedSubtotal, tax, total };
}

export function splitTotalIntoSubtotalAndTax(totalAmount) {
  const total = Number(totalAmount || 0);
  const subtotal = Number((total / (1 + ORDER_TAX_RATE)).toFixed(2));
  const tax = Number((total - subtotal).toFixed(2));
  return { subtotal, tax, total };
}
